import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "@babel/runtime/helpers/esm/get";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["SuperClass"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
import Fetcher from './Fetcher';

// Always call this with `new` to make the abstraction over the inner class
// transparent to module consumers
var ExhaustivePaginatedFetcher = function ExhaustivePaginatedFetcher() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$SuperClass = _ref.SuperClass,
    SuperClass = _ref$SuperClass === void 0 ? Fetcher : _ref$SuperClass,
    args = _objectWithoutProperties(_ref, _excluded);
  var ExhaustivePaginatedFetcher = /*#__PURE__*/function (_SuperClass) {
    function ExhaustivePaginatedFetcher() {
      _classCallCheck(this, ExhaustivePaginatedFetcher);
      return _callSuper(this, ExhaustivePaginatedFetcher, arguments);
    }
    _inherits(ExhaustivePaginatedFetcher, _SuperClass);
    return _createClass(ExhaustivePaginatedFetcher, [{
      key: "combinePages",
      value: function combinePages(pages) {
        return pages.reduce(function (accumulator, page) {
          return [].concat(_toConsumableArray(accumulator), _toConsumableArray(page));
        }, []);
      }
    }, {
      key: "get",
      value: function () {
        var _get2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(url) {
          var _this = this;
          var additionalParams,
            params,
            totalItems,
            itemsPerPage,
            _args = arguments;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                additionalParams = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                params = {
                  method: 'GET',
                  headers: _superPropGet(ExhaustivePaginatedFetcher, "callHeaders", this, 3)([])
                };
                return _context.abrupt("return", _superPropGet(ExhaustivePaginatedFetcher, "fetch", this, 3)([_superPropGet(ExhaustivePaginatedFetcher, "appendQueryParams", this, 3)([url, additionalParams]), params]).then(function (response) {
                  // analyze properties of the first page response
                  // before getting its json body
                  totalItems = parseInt(response.headers.get('total'), 10);
                  itemsPerPage = parseInt(response.headers.get('per-page'), 10);
                  return response.json();
                }).then(function (initial) {
                  if (totalItems > itemsPerPage) {
                    // create an array of page numbers, and use it to generate an array of
                    // get calls to the same url, but with different page numbers
                    var pageCount = Math.ceil(totalItems / itemsPerPage) - 1;
                    var pages = _toConsumableArray(Array(pageCount).keys()).map(function (p) {
                      return _superPropGet(ExhaustivePaginatedFetcher, "get", _this, 3)([url, _objectSpread(_objectSpread({}, additionalParams), {}, {
                        page: p + 2,
                        per_page: itemsPerPage
                      })]);
                    });
                    return Promise.all(pages).then(function (pageResponses) {
                      return [].concat(_toConsumableArray(initial), _toConsumableArray(_this.combinePages(pageResponses)));
                    });
                  } else {
                    return initial;
                  }
                }));
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee, this);
        }));
        function get(_x) {
          return _get2.apply(this, arguments);
        }
        return get;
      }()
    }]);
  }(SuperClass);
  return new ExhaustivePaginatedFetcher(args);
};
export default ExhaustivePaginatedFetcher;